import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

import flowfact from "../images/ff_logo_16x9.jpg";
import propstack from "../images/ps_logo_16x9.jpg";
import retroBoardLogo from "../images/retro_board_logo_2.png";
import cutLogo from "../images/cut_onl_logo.png";
import performer from "../images/performer_logo.png";
import happy from "../images/happy.gif";

const projects = [
  {
    name: "FLOWFACT Performer CRM",
    description: `Onpremise & Cloud CRM product for the real estate industry.`,
    image: performer,
    tags: ["VB", "VBS", "MSSQL", "C++", "JavaScript"],
    ctaLabel: "Discontinued",
    ctaDisabled: true,
    imageSx: {
      objectFit: "contain",
      padding: "12px",
      background: "#233",
    },
  },
  {
    name: "FLOWFACT hAPPy CRM",
    description: `Cloud CRM product for the real estate industry.`,
    image: happy,
    tags: ["Cloud", "Java", "Eclipse", "Spring Boot", "MSSQL", "MySQL"],
    ctaLabel: "Discontinued",
    ctaDisabled: true,
    imageSx: {
      objectFit: "contain",
      padding: "12px",
      background: "#233",
    },
  },
  {
    name: "FLOWFACT Platform",
    description: `CRM Platform for multiple CRM Systems like the FLOWFACT CRM. `,
    image: flowfact,
    tags: ["AWS", "Java", "Kotlin", "Spring Boot", "TypeScript", "React", "Node", "Serverless", "MongoDB", "PostgreSQL", "ELS", "Redis/Valkey", "Docker", "Jenkins", "Kafka"],
    ctaLabel: "Reference",
    ctaUrl: "https://flowfact.de",
  },
  {
    name: "Propstack CRM",
    description: `Cloud CRM product for the real estate industry.`,
    image: propstack,
    tags: ["Ruby on Rails", "TypeScript", "Redis", "PostgreSQL", "GraphQL", "AWS", "Docker"],
    ctaLabel: "Reference",
    ctaUrl: "https://www.propstack.de",
  },
  {
    name: "Retro Board",
    description: `Private lightwaight web application for retrospectives in agile teams.`,
    image: retroBoardLogo,
    tags: ["Ruby on Rails", "TypeScript", "Redis", "PostgreSQL", "React"],
    ctaLabel: "Reference",
    ctaUrl: "https://cut.onl/retro",
    overlayText: "RETRO BOARD",
  },
  {
    name: "CUT.ONL",
    description: `Short link service for sharing and redirecting URLs. Forked from `,
    image: cutLogo,
    tags: ["Node.js", "TypeScript", "Redis", "PostgreSQL"],
    ctaLabel: "Reference",
    ctaUrl: "https://cut.onl/",
    descriptionLinkText: "Kutt",
    descriptionLinkUrl: "https://github.com/thedevs-network/kutt",
    sourceLabel: "Source",
    sourceUrl: "https://github.com/FallenAngel666/kutt",
    overlayText: "CUT.ONL",
  }
];

const Portfolio = () => {
  return (
    <Box
      component="section"
      sx={{
        background: "#233",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Box sx={{ height: "100%", overflowY: "auto", padding: "2rem 0" }}>
        <Grid
          container
          justifyContent="center"
          spacing={4}
          sx={{
            padding: "0 0.5rem 2rem",
          }}
        >
          {/* Projects */}
          {projects.map((project, i) => (
            <Grid item xs={12} sm={8} md={4} key={i}>
              <Card sx={{ maxWidth: 345, margin: "0 auto" }}>
                <CardActionArea sx={{ cursor: "default" }}>
                  {project.overlayText ? (
                    <Box
                      sx={{
                        height: 140,
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        padding: "0 1.25rem",
                        background: "#233",
                      }}
                    >
                      <Box
                        component="img"
                        src={project.image}
                        alt={project.name}
                        sx={{ height: 90, width: 90, objectFit: "contain" }}
                      />
                      <Typography
                        variant="h5"
                        sx={{
                          color: "#f1e3c8",
                          fontWeight: 700,
                          letterSpacing: "0.15em",
                          textTransform: "uppercase",
                        }}
                      >
                        {project.overlayText}
                      </Typography>
                    </Box>
                  ) : (
                    <CardMedia
                      component="img"
                      alt={project.name}
                      height="140"
                      sx={{ objectFit: "cover", ...project.imageSx }}
                      image={project.image}
                    />
                  )}
                  <CardContent>
                    <Typography variant="h5" gutterBottom>
                      {project.name}
                    </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {project.description}
                    {project.descriptionLinkUrl ? (
                      <a
                        href={project.descriptionLinkUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "inherit" }}
                      >
                        {project.descriptionLinkText}
                      </a>
                    ) : null}
                  </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.5rem",
                        marginTop: "0.75rem",
                      }}
                    >
                      {project.tags.map((tag) => (
                        <Chip key={tag} label={tag} size="small" />
                      ))}
                    </Box>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    variant="outlined"
                    disabled={project.ctaDisabled}
                    component="a"
                    href={project.ctaUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {project.ctaLabel || "Reference"}
                  </Button>
                  {project.sourceUrl ? (
                    <Button
                      size="small"
                      color="primary"
                      variant="outlined"
                      component="a"
                      href={project.sourceUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {project.sourceLabel || "Source"}
                    </Button>
                  ) : null}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Portfolio;
